import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { DomainID } from '~src/settings/bridge-settings/sections/types/Domain';
import { DomainUpdateType } from '~src/settings/bridge-settings/serverApi/requests/UpdateEdgePoolRequest';
import { IUpdateBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/UpdateBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../../MoreActionsMenu';
import { DomainPermission } from '../../types/DomainPermission';
import { DomainTableItem } from '../../types/DomainTableItem';
import { DomainValidationStatus } from '../../types/DomainValidationStatus';
import { PoolID } from '../../types/PoolID';
import { createDomainTableItems } from '../../utils/DomainUtilities';
import { getGeneralErrorMessage } from '../../utils/EdgePoolErrorUtilities';
import { AddNewDomainDialog, AddNewDomainDialogInputProps, AddNewDomainDialogState } from './AddNewDomainDialog';

export function openEditDomainDialog(
    domainEditableProperties: { domainName: string, domainPermission: DomainPermission },
    onEditDomainDialogSave: (domainName: string, domainPermission: DomainPermission) => void,
    otherDomainNames: ReadonlyArray<string>,
    poolDomainNames: ReadonlyArray<string>,
    poolID: PoolID,
    poolName: string
) {
    const action = (_props: AddNewDomainDialogInputProps, state: AddNewDomainDialogState) => {
        onEditDomainDialogSave(state.domainName, state.domainPermission);
        return Promise.resolve();
    };
    const dialogInstance = openReactActionDialog({
        title: Messages.dataConnectSiteSettingsEditDomain({POOL_NAME: poolName}),
        bodyComponent: AddNewDomainDialog,
        initialBodyProps: {poolID, poolName, otherDomainNames, poolDomainNames},
        initialDialogState: { ...domainEditableProperties, domainValidationStatus: DomainValidationStatus.NO_ERROR},
        actionDisabled: (_props, state) => state.domainValidationStatus !== DomainValidationStatus.NO_ERROR,
        actionName: Messages.save(),
        action: action,
        isActionDelete: false,
        dialogWidth: TabDialogWidth.width375px,
        dismissDialogOnActionFailed: false
    });

    return Promise.resolve(dialogInstance.result);
}

export function openEditPoolDomainDialog(actionItem: ActionItemInfo) {
    const onEditDomainDialogSave = (domainName: string, domainPermission: DomainPermission) => {

        BaasEdgePoolAndCluster.updateBaasPool({
          poolId: actionItem.poolId,
          displayName: null,
          domainChange: { change: DomainUpdateType.Remove, domainId: actionItem.domain.domainName  as DomainID},
          DataConnectSettingsVersion: '0'
        }).then((resultForRemove: IUpdateBaasEdgePoolResult) => {
          if (resultForRemove.errors) {
            ToasterService.instance.pop({
              type: ToastType.Error,
              text: getGeneralErrorMessage(resultForRemove.errors[0].code, resultForRemove.errors[0].message)
            });
          }
          if (resultForRemove.success) {
            BaasEdgePoolAndCluster.updateBaasPool({
              poolId: actionItem.poolId,
              displayName: null,
              domainChange: { change: DomainUpdateType.Add, domainId: domainName as DomainID },
              DataConnectSettingsVersion: '0'
            })
              .then((resultForAdd: IUpdateBaasEdgePoolResult) => {
                actionItem.refreshPoolsAndClusters();
                if (resultForAdd.success) {
                  ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsEditDomainSuccess() });
                }
                if (resultForAdd.errors) {
                  ToasterService.instance.pop({
                    type: ToastType.Error,
                    text: getGeneralErrorMessage(resultForAdd.errors[0].code, resultForAdd.errors[0].message)
                  });
                }
              });
          }
        });
      };
      const domainEditableProperties = {
        domainName: actionItem.domain.domainName,
        poolID: actionItem.poolId,
        poolName: actionItem.poolName,
        domainPermission: DomainPermission.ALLOW,
      };
      const domainTableItems: ReadonlyArray<DomainTableItem> = createDomainTableItems(actionItem.userDefinedPools, {});
      const bridgeDomainNames: ReadonlyArray<string> = Object.keys(actionItem.bridgeDomains);

      openEditDomainDialog(domainEditableProperties, onEditDomainDialogSave, domainTableItems.map((item: DomainTableItem) => item.domainName),
                            bridgeDomainNames, actionItem.poolId, actionItem.poolName);
}

